<app-dialog
  #dialog
  [key]="'org-chart-import-review-modal'"
  [action]="'org-chart-import-review'"
  [headerTheme]="'simple'"
  [title]="'Revisar importação'"
  [appendTo]="'body'"
  [hideDefaultFooter]="true"
  [maxWidth]="'1120px'"
  (onClose)="onDialogClosed()">
  @if (item(); as current) {
    <div class="org-chart-review">
      <p class="org-chart-review__subtitle">
        {{ current.fileName }} · {{ rows().length }}
        {{ rows().length === 1 ? 'item lido' : 'itens lidos' }}. Desmarque o que não deve entrar no
        grupo.
      </p>

      @if (summary(); as s) {
        <div class="org-chart-review__chips">
          <span class="review-tag review-tag--success"
            >{{ s.created }} {{ s.created === 1 ? 'nova' : 'novas' }}</span
          >
          <span class="review-tag review-tag--info"
            >{{ s.existing }} já {{ s.existing === 1 ? 'cadastrada' : 'cadastradas' }}</span
          >
          <span class="review-tag review-tag--warn"
            >{{ s.attention }} {{ s.attention === 1 ? 'precisa' : 'precisam' }} de atenção</span
          >
          <span class="review-tag review-tag--navy">{{ s.persons }} pessoa física (não entra)</span>
        </div>
      }

      @if (warnings().length) {
        <ul class="org-chart-review__warnings">
          @for (warning of warnings(); track $index) {
            <li><i class="pi pi-info-circle"></i> {{ warning }}</li>
          }
        </ul>
      }

      <div class="org-chart-review__table-wrapper">
        <table class="org-chart-review__table">
          <thead>
            <tr>
              <th class="col-check"></th>
              <th class="col-company">Empresa (razão social da Receita)</th>
              <th class="col-cnpj">CNPJ</th>
              <th class="col-action">O que acontece</th>
              <th>Avisos</th>
              <th class="col-quote"></th>
            </tr>
          </thead>
          <tbody>
            @for (row of rows(); track row.node.tempId) {
              <tr
                [class.row--person]="row.isPerson"
                [class.row--warn]="row.editableCnpj && row.node.action === 'NeedsCnpj'"
                [class.row--danger]="row.editableCnpj && row.node.action === 'InvalidCnpj'"
                [class.row--excluded]="!row.isPerson && !isIncluded(row)">
                <td class="col-check">
                  @if (!row.isPerson) {
                    <span
                      class="row-check"
                      [class.row-check--disabled]="row.isLocked"
                      [attr.aria-disabled]="row.isLocked || null"
                      [title]="row.isLocked ? 'Esta empresa não pode entrar neste grupo' : ''">
                      <app-checkbox
                        [checkbox]="rowCheckboxes()[row.node.tempId]"
                        (sendCheckedChange)="onRowChecked(row, $event)" />
                    </span>
                  }
                </td>
                <td class="col-company">
                  <div class="company-cell" [style.padding-left.px]="row.level * 20">
                    @if (row.level > 0) {
                      <span class="company-cell__branch">└</span>
                    }
                    <div>
                      <div class="company-cell__name" [title]="row.name">{{ row.name }}</div>
                      @if (row.documentNameWhenDifferent) {
                        <div class="company-cell__doc" [title]="row.documentNameWhenDifferent">
                          no documento: “{{ row.documentNameWhenDifferent }}”
                        </div>
                      } @else if (row.node.action === 'NeedsCnpj') {
                        <div class="company-cell__doc">o documento não traz CNPJ</div>
                      } @else if (row.node.action === 'InvalidCnpj' && row.node.cnpjAsWritten) {
                        <div class="company-cell__doc">lido: {{ row.node.cnpjAsWritten }}</div>
                      }
                    </div>
                  </div>
                </td>
                <td class="col-cnpj">
                  @if (row.editableCnpj) {
                    <app-input
                      type="cnpj"
                      theme="small"
                      placeholder="Digite o CNPJ"
                      [id]="'org-chart-review-cnpj-' + row.node.tempId"
                      [unmask]="true"
                      [error]="false"
                      [textCenter]="false"
                      [inputClass]="cnpjError(row) ? 'input__input--error' : ''"
                      [ngModel]="typedCnpj(row)"
                      (ngModelChange)="onCnpjTyped(row, $event)"
                      [ngModelOptions]="{ standalone: true }" />
                  } @else if (row.isPerson) {
                    —
                  } @else {
                    {{ formatCnpj(row.node.cnpj) }}
                  }
                </td>
                <td class="col-action">
                  <span class="review-tag" [ngClass]="'review-tag--' + row.tag.tone">{{
                    row.tag.label
                  }}</span>
                </td>
                <td class="col-warnings">
                  @if (cnpjError(row); as error) {
                    <span
                      class="col-warnings__error"
                      [class.col-warnings__error--danger]="row.node.action === 'InvalidCnpj'"
                      >{{ error }}</span
                    >
                  }
                  @for (warning of row.warnings; track $index) {
                    <span>{{ warning }}</span>
                  }
                </td>
                <td class="col-quote">
                  @if (row.node.evidence?.quote) {
                    <button
                      type="button"
                      class="quote-button"
                      title="Ver trecho do documento"
                      aria-label="Ver trecho do documento"
                      (click)="showEvidence(row, $event, evidencePopover)">
                      <i class="pi pi-comment"></i>
                    </button>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  }

  <ng-template #footer>
    <div class="dialog__footer org-chart-review__footer">
      @if (primaryCheckbox(); as primary) {
        <div class="org-chart-review__primary">
          <app-checkbox [checkbox]="primary" (sendCheckedChange)="onPrimaryChecked($event)" />
          <span class="org-chart-review__primary-label" (click)="togglePrimary()">
            Definir <b>{{ primaryName() }}</b> como empresa principal
          </span>
        </div>
      }
      <span class="org-chart-review__count" [title]="includedTitle()">
        {{ includedCount()?.total ?? 0 }}
        {{ (includedCount()?.total ?? 0) === 1 ? 'entra' : 'entram' }}
        no grupo
      </span>
      @if (state.canDiscard()) {
        <app-button
          label="Descartar"
          theme="link"
          size="small"
          [noMargin]="true"
          [disabled]="state.isDiscarding() || state.isApplying()"
          (sendButtonClick)="discard()" />
      }
      <app-button
        label="Revisar depois"
        theme="white"
        size="small"
        [noMargin]="true"
        [disabled]="state.isApplying()"
        (sendButtonClick)="close()" />
      @if (state.canApply()) {
        <app-button
          label="Aplicar ao grupo"
          size="small"
          [noMargin]="true"
          [disabled]="!canSubmit()"
          [isLoading]="state.isApplying()"
          [loadingText]="'Aplicando...'"
          (sendButtonClick)="submitAction()" />
      }
    </div>
  </ng-template>
</app-dialog>

<p-popover #evidencePopover appendTo="body" styleClass="org-chart-review-evidence">
  @if (evidenceRow(); as row) {
    <div class="evidence">
      <p class="evidence__head">
        Trecho do documento{{
          row.node.evidence?.page ? ', página ' + row.node.evidence?.page : ''
        }}
      </p>
      <blockquote class="evidence__quote">“{{ row.node.evidence?.quote }}”</blockquote>
    </div>
  }
</p-popover>
